@if (loadingState) {
<div class="overlay-spinner">
  <app-spinner [customLoader]="true" [bgColor]="primaryColor"></app-spinner>
</div>
}
